import { render } from "./review-feedback.vue?vue&type=template&id=ef99b8d2&ts=true"
import script from "./review-feedback.vue?vue&type=script&lang=ts"
export * from "./review-feedback.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__